/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};

GS.Filters.ColorEffects=new Class({
    //Extends: GS.BaseClass,
    Extends: GS.Filters.BaseFilter,
    class_name:'GS.Filters.ColorEffects',
    options:{
        'dx': 0,
        'contrast':0,
        'contrast_matrix':[],
        'brightness':0,
        'brightness_matrix':[],
        'staturation': 0,
        'staturation_matrix':[],
        'sepia':false,
        'bw':false,
        'whiteColor' : {'r':255,'g':255,'b':255},
        'blackColor' : {'r':0,'g':0,'b':0}
    },
    filter: {
        'id':0,
        'container':null,
        'saturation':null,
        'brightness':null,
        'color':null,
        'contrast':null
    }
});


GS.Filters.ColorEffects.prototype.createFilter=function(){
    var w = parseFloat(this.defs.ownerSVGElement.getAttribute('width')),
            h = parseFloat(this.defs.ownerSVGElement.getAttribute('height'));   
        var fID,
            //f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB', 'filterUnits': "objectBoundingBox"}),
            f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','filterUnits': "userSpaceOnUse", 'x': -w,'y': -h,'width': 3*w,'height': 3*h/*,'enable-background':'accumulate'*/});
           


    this.filter.container=f;
    //this.addColorFilter();
    //this.defs.adopt(f);
};
/**
* Create Color Filter element     
* @returns {void}
*/
GS.Filters.ColorEffects.prototype.addColorFilter=function(){
    var fID,saturation,brightness,contrast,sepia,bw,feMerge,feMergeComposit,feCompTransfert,funcR,funcG,funcB;
    //console.debug(this.options.colors);

    try {

        feCompTransfert = new Element('feComponentTransfer', {'in': 'SourceGraphic', 'result': 'result'});
        this.funcR = new Element('feFuncR', {'type': 'table', 'tableValues': '0 1'});
        this.funcG = new Element('feFuncG', {'type': 'table', 'tableValues': '0 1'});
        this.funcB = new Element('feFuncB', {'type': 'table', 'tableValues': '0 1'});

        feCompTransfert.adopt([this.funcR, this.funcG, this.funcB]);
        this.remapColor(this.options.blackColor, 0);
        this.remapColor(this.options.whiteColor, 1);


        saturation = new Element('feColorMatrix', {
            'in': 'result',
            'type': 'matrix',
            'result': 'saturated',
            'values': '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'
        });
        this.setImageSaturation(this.options.colors.saturation);
        saturation.set('values', this.options.colors.saturation_matrix.join(' '));
        this.filter.saturation = saturation;

        brightness = new Element('feColorMatrix', {
            'in': 'saturated',
            'type': 'matrix',
            'result': 'brightness',
            'values': '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'
        });
        this.setImageBrightness(this.options.colors.brightness);
        brightness.set('values', this.options.colors.brightness_matrix.join(' '));
        this.filter.brightness = brightness;

        contrast = new Element('feColorMatrix', {
            'in': 'brightness',
            'type': 'matrix',
            'result': 'composit',
            'values': ''
        });
        this.setImageContrast(this.options.colors.contrast);
        contrast.set('values', this.options.colors.contrast_matrix.join(' '));
        this.filter.contrast = contrast;

        sepia = new Element('feColorMatrix', {'in': 'composit', 'result': 'composit', 'type': 'matrix', 'values': ''});
        this.convertToSepia(this.options.colors.sepia);
        sepia.set('values', this.options.colors.sepia_matrix.join(' '));
        this.filter.sepia = sepia;

        bw = new Element('feColorMatrix', {'in': 'composit', 'type': 'matrix', 'result': 'composit', 'values': ''});
        this.convertToBW(this.options.colors.bw);
        bw.set('values', this.options.colors.bw_matrix.join(' '));
        this.filter.bw = bw;


        feMerge = new Element('feMerge');
        feMergeComposit = new Element('feMergeNode', {'in': 'composit', 'mode': 'normal'});
        feMerge.adopt(feMergeComposit);

        this.filter.container.adopt([feCompTransfert, saturation, , brightness, contrast, sepia, bw]);
    }catch(err){
        console.error(err);
    }
};

GS.Filters.ColorEffects.prototype.remapColor = function(color,index) {
        var tableValues;
        
        //Remap red....
        tableValues = this.funcR.getAttribute('tableValues').split(' ');
        tableValues[index] = color.r / 255;
        this.funcR.setAttribute('tableValues', tableValues.join(' '));

        //Remap green....     
        tableValues = this.funcG.getAttribute('tableValues').split(' ');
        tableValues[index] = color.g / 255;
        this.funcG.setAttribute('tableValues', tableValues.join(' '));
        
        //Remap blue....
        tableValues = this.funcB.getAttribute('tableValues').split(' ');
        tableValues[index] = color.b / 255;
        this.funcB.setAttribute('tableValues', tableValues.join(' '));
};

            

GS.Filters.ColorEffects.prototype.update=function(obj){
    
    this.setImageBrightness(obj.colors.brightness);
    this.setImageContrast(obj.colors.contrast);
    this.setImageSaturation(obj.colors.saturation);
    this.convertToSepia(obj.colors.sepia);
    this.convertToBW(obj.colors.bw);
    
    this.filter.saturation.set('values',this.options.colors.saturation_matrix.join(' '));
    this.filter.brightness.set('values',this.options.colors.brightness_matrix.join(' '));
    this.filter.contrast.set('values',this.options.colors.contrast_matrix.join(' '));
    this.filter.sepia.set('values',this.options.colors.sepia_matrix.join(' '));
    this.filter.bw.set('values',this.options.colors.bw_matrix.join(' '));
};

/**
 * 
 * @param {boolean} v
 * @returns {void}
 */
GS.Filters.ColorEffects.prototype.convertToSepia=function(v){
    var cMatrix = [],
        amount = 0.5,
        r=(v) ? (0.393 + 0.607 * (1 - amount)) : 1,
        g=(v) ? (0.686 + 0.314 * (1 - amount)) : 1,
        b=(v) ? (0.131 + 0.869 * (1 - amount)) : 1,

        rx=(v) ? (0.769 - 0.769 * (1 - amount)) : 0,
        ry=(v) ? (0.189 - 0.189 * (1 - amount)) : 0,

        gx=(v) ? (0.349 - 0.349 * (1 - amount)) : 0,
        gy=(v) ? (0.168 - 0.168 * (1 - amount)) : 0,

        bx=(v) ? (0.272 - 0.272 * (1 - amount)) : 0,
        by=(v) ? (0.534 - 0.534 * (1 - amount)) : 0;

        
        

    cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);    // red
    cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
    cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha 
    this.options.colors.sepia_matrix=cMatrix;
 };
 
 /**
 * 
 * @param {boolean} v
 * @returns {void}
 */
GS.Filters.ColorEffects.prototype.convertToBW=function(v){
   //b&w matrix [0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0]
   //normal matrix [1 0 0 0 0 0 0 1 0 0 0 0 0 0 1 0 0 0 0 0 1 0] 
    var cMatrix = [],
        r=(v) ? 0.33 : 1,
        g=(v) ? 0.33 : 1,
        b=(v) ? 0.33 : 1,

        rx=(v) ? 0.33 : 0,
        ry=(v) ? 0.33 : 0,

        gx=(v) ? 0.33 : 0,
        gy=(v) ? 0.33 : 0,

        bx=(v) ? 0.33 : 0,
        by=(v) ? 0.33 : 0;

    cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);    // red
    cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
    cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha 
    

    this.options.colors.bw_matrix=cMatrix;
 };

/**
* Change image saturation
* @param {number} v          :[-100,100] default to 0
* @returns {void}
*/
GS.Filters.ColorEffects.prototype.setImageSaturation=function(v){
    var cMatrix = [],lumaR,lumaG,lumaB,i,r,g,b;
    lumaR = 0.212671;
    lumaG = 0.71516;
    lumaB = 0.072169;
    v=v/100+1;

    i = (1 - v);
    r = (i * lumaR);
    g = (i * lumaG);
    b = (i * lumaB);

    cMatrix = cMatrix.concat([(r + v), g, b, 0, 0]);    // red
    cMatrix = cMatrix.concat([r, (g + v), b, 0, 0]);    // green
    cMatrix = cMatrix.concat([r, g, (b + v), 0, 0]);    // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha
    
    this.options.colors.saturation_matrix=cMatrix;
};


/**
* Set image Brightness
* @param {number} s
* @returns {void}
*/
GS.Filters.ColorEffects.prototype.setImageBrightness=function(s){
    var cMatrix=[];
    s=-Number(s)/100;

    cMatrix=cMatrix.concat([1,0,0,0,s]);// red
    cMatrix=cMatrix.concat([0,1,0,0,s]);// green
    cMatrix=cMatrix.concat([0,0,1,0,s]);// blue
    cMatrix=cMatrix.concat([0,0,0,1,0]);// alpha
    
    this.options.colors.brightness_matrix=cMatrix;
};

/**
* Set the image contrast
* 
* @param {Number} v          :[-100,100] default to 0
* @returns {void}
*/
GS.Filters.ColorEffects.prototype.setImageContrast=function(v){
    var cMatrix=[],s_d;
    v=Number(v);
    v /= 100;

    s = v + 1;
    _d = 0.5*(1 - s);

    cMatrix = cMatrix.concat([s, 0, 0, 0, _d]);  // red
    cMatrix = cMatrix.concat([0, s, 0, 0, _d]);  // green
    cMatrix = cMatrix.concat([0, 0, s, 0, _d]);  // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);  // alpha

    this.options.colors.contrast_matrix=cMatrix;
};